"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Input component - form input with validation
 */
const react_1 = require("react");
require("../../styles/components/input.scss");
/**
 * Input component with label, error, and helper text support
 * @param props - InputProps
 * @param ref - Forwarded ref to the input element
 * @returns Input component
 */
exports.Input = (0, react_1.forwardRef)((_a, ref) => {
    var { label, error, helperText, fullWidth = false, className = '', id, disabled = false, required = false } = _a, rest = __rest(_a, ["label", "error", "helperText", "fullWidth", "className", "id", "disabled", "required"]);
    const containerClasses = ['input-container', fullWidth ? 'input-container--full-width' : '']
        .filter(Boolean)
        .join(' ');
    const inputClasses = ['input', error ? 'input--error' : '', disabled ? 'input--disabled' : '', className]
        .filter(Boolean)
        .join(' ');
    return ((0, jsx_runtime_1.jsxs)("div", { className: containerClasses, children: [label && ((0, jsx_runtime_1.jsxs)("label", { htmlFor: id, className: "input__label", children: [label, required && (0, jsx_runtime_1.jsx)("span", { className: "input__label--required", "aria-hidden": "true" })] })), (0, jsx_runtime_1.jsx)("input", Object.assign({ ref: ref, id: id, className: inputClasses, disabled: disabled, required: required, "aria-invalid": error ? 'true' : 'false', "aria-describedby": error ? `${id}-error` : helperText ? `${id}-helper` : undefined }, rest)), error && ((0, jsx_runtime_1.jsx)("span", { id: `${id}-error`, className: "input__error", role: "alert", children: error })), helperText && !error && ((0, jsx_runtime_1.jsx)("span", { id: `${id}-helper`, className: "input__helper", children: helperText }))] }));
});
exports.Input.displayName = 'Input';
exports.default = exports.Input;
